import React, { Component } from 'react'
// import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import { ResponsiveContext } from 'grommet'
import loadable from '@loadable/component'
// import Snowfall from 'react-snowfall'
import Measure from 'react-measure'
import { connect } from 'react-redux'
import Layout from '../../layout/GeneralLayout'
import {
  showTurntable,
  setTurntableSize,
  setChoices,
  setResultSelected,
} from '../../redux/rng/actions'
import Turntable from '../../component/Turntable'
import Footer from '../../component/Footer'
import RNGInputs from '../../component/ReactRNG'
import RNGSharedImage from '../../images/tools/Number-Picker-Wheel.png'
import SEO from '../../component/SEO'
// import { getShareLink } from '../../redux/shareWheel/actions'
// import { rgba } from 'polished'
import PageTitle from '../../component/PageComponent/PageTitle'
import withWheelToolHOC from '../../component/HOC/withWheelToolHOC'
import FullScreenButton from '../../component/Button/FullScreenButton'
import {
  TurntableBox,
  BGContainer,
  ContainerTool,
  WheelWhiteBox,
  WheelBox,
  FullScreen,
  // InputBox,
  WheelPlaceholder,
} from '../../component/PageComponent/Box'
import { RelativeBox } from '../../component/Common'
import InputBox from '../../component/PageComponent/InputBox'
import AllResultsButton from '../../component/Button/AllResultsButton'
// import ToolTitle from '../../component/Title'
import ArticleContent from '../../component/Section/Content'
import SpinnerFullScreen from '../../component/Spinner/SpinnerFullScreen'
import BackgroundAllResults from '../../component/AllResults/BackgroundAllResults'
import ToolSettings from '../../component/ToolSettings'
import Versioning from '../../component/PageComponent/Versioning'
import MiddleBox from '../../component/PageComponent/MiddleBox'
import VolumeButton from '../../component/Button/VolumeButton'
import UnhideInputButton from '../../component/Button/UnhideInputButton'
// import FloatingTitle from '../../component/Title/FloatingTitle'
import FloatingDisplay from '../../component/ReactRNG/floatingDisplay'
import FloatingBox from '../../component/PageComponent/FloatingBox'
import withProvider from '../../component/HOC/withProvider'
import InputShield from '../../component/PageComponent/InputShield'
import ShareModeButton from '../../component/Button/ShareModeButton'
import NumberContainer from '../../component/ReactRNG/numberContainer'
import SpinQuantity from '../../component/PageComponent/SpinQuantity'
import { replaceCDN } from '../../utils'
import { fontSizes } from '../../component/ReactTurntable/TurntableFontSize'

const Modal = loadable(() =>
  import('../../component/Modals/ResultModal/RNGResultModal'),
)
// const ToolSettings = loadable(() =>
//   pMinDelay(import('../../component/ToolSettings'), 200),
// )
// const ArticleContent = loadable(() => import('../../component/Section/Content'))
const AllResults = loadable(() => import('../../component/AllResults'), {
  fallback: (
    <BackgroundAllResults justify="center">Loading...</BackgroundAllResults>
  ),
})

const ModifyTitleModal = loadable(
  () => import('../../component/Modals/ModifyTitleModal'),
  {
    fallback: <SpinnerFullScreen caption="Please wait..." />,
  },
)

const LoadSaveModal = loadable(
  () => import('../../component/Modals/LoadSaveModal'),
  {
    fallback: <SpinnerFullScreen caption="Please wait..." />,
  },
)

// const NumberBox = styled(Box)`
//   position: absolute;
//   z-index: 9;
//   align-self: center;
//   align-items: center;
//   top: calc(50% + 47px); //turntable button 80px
// `

const mapState = state => ({
  resultSelected: state.rng.resultSelected,
  choices: state.rng.choices,
  turnTable: state.rng.turnTable,
  turnTableSize: state.rng.turnTableSize,
  bgColor: state.settings.bgColor.color,
  // getShareLoading: state.async.getShareLoading,
  typeOption: state.rng.typeOption,
  spinQuantity: state.settings.spinBehavior.spinQuantity,
  bgImage: state.settings.bgImage,
  modifyTitleModal: state.modal.modifyTitleModal,
  digitRanges: state.rng.digitRanges,
  boardIndex: state.rng.boardIndex,
  loadSaveModalDisplay: state.modal.loadSaveModalDisplay,
  // donorboxLoaded: state.common.donorboxLoaded,
})

const actions = {
  setChoices,
  showTurntable,
  setTurntableSize,
  // loadDonorbox,
  setResultSelected,
  // getShareLink,
}

class RandomNumberWheel extends Component {
  state = {
    turntableBoxSize: 300,
    choices: [],
    bgColor: 'var(--bgPlaceholder)',
    allResultsOpen: false,
    modalPreloaded: false,
    bgImage: { on: false, src: null },
    spinQuantityEnabled: false,
  }

  checkIsBlankWheel = () => {
    return this.props.choices.length === 0
  }

  convertChoices = () => {
    const { typeOption, boardIndex, digitRanges, choices } = this.props
    if (typeOption === 0) {
      return choices
    } else {
      const digitChoices = Array.from(
        { length: digitRanges[boardIndex][1] - digitRanges[boardIndex][0] + 1 },
        (_, i) => i + digitRanges[boardIndex][0],
      )
      return digitChoices
    }
  }

  componentDidMount() {
    // this.donorboxInit()
    this.setState({
      bgColor: this.props.bgColor,
      turntableBoxSize: this.props.turnTableSize,
      bgImage: this.props.bgImage,
      spinQuantityEnabled: this.props.spinQuantity,
    })
    // if (this.props.randomStart) {      // not need because rng will call setChoices initially
    //   this.props.setStartRotate(2 * Math.PI * Math.random())
    // }
    const isBlankWheel = this.checkIsBlankWheel()
    const choices = this.convertChoices()
    const turnTable = (
      <Turntable
        page="rng"
        choices={choices}
        size={this.props.turnTableSize}
        completed={choice => this.props.setResultSelected(choice)}
        gaEvent={{ category: 'RNG Actions', action: 'Spin Number Wheel' }}
        started={() => {
          if (!this.state.modalPreloaded) {
            Modal.preload()
            this.setState({ modalPreloaded: true })
          }
        }}
        fontSize={fontSizes.rng.normal}
        isBlankWheel={isBlankWheel}
      />
    )
    this.props.showTurntable(turnTable)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.bgColor !== this.props.bgColor) {
      this.setState({ bgColor: this.props.bgColor })
    }
    if (prevState.bgImage !== this.props.bgImage) {
      this.setState({ bgImage: this.props.bgImage })
    }
    if (prevState.spinQuantityEnabled !== this.props.spinQuantity) {
      this.setState({ spinQuantityEnabled: this.props.spinQuantity })
    }
    if (
      this.props.turnTableSize !== prevProps.turnTableSize &&
      this.props.turnTable !== null // only happen on initial render without local storage
    ) {
      this.props.showTurntable(null)
    }
    if (this.props.turnTable === null) {
      const isBlankWheel = this.checkIsBlankWheel()
      const choices = this.convertChoices()
      if (this.props.turnTableSize !== prevProps.turnTableSize) {
        this.setState({ turntableBoxSize: this.props.turnTableSize })
      }
      let fontSize = fontSizes.rng.normal
      if (this.props.handleFullScreen.active) fontSize += fontSizes.rng.extra
      const turnTable = (
        <Turntable
          page="rng"
          choices={choices}
          size={this.props.turnTableSize}
          completed={choice => this.props.setResultSelected(choice)}
          gaEvent={{ category: 'RNG Actions', action: 'Spin Number Wheel' }}
          started={() => {
            if (!this.state.modalPreloaded) {
              Modal.preload()
              this.setState({ modalPreloaded: true })
            }
          }}
          fontSize={fontSize}
          fullScreenActive={this.props.handleFullScreen.active}
          isBlankWheel={isBlankWheel}
        />
      )
      this.props.showTurntable(turnTable)
    }
  }

  render() {
    const {
      resultSelected,
      turnTable,
      setTurntableSize,
      showTurntable,
      getShareLoading,
      handleFullScreen,
      typeOption,
      handleHideInput,
      modifyTitleModal,
      loadSaveModalDisplay,
    } = this.props
    const {
      bgColor,
      turntableBoxSize,
      allResultsOpen,
      bgImage,
      spinQuantityEnabled,
    } = this.state
    return (
      <Layout>
        <ResponsiveContext.Consumer>
          {size => {
            return (
              <>
                {getShareLoading && (
                  <SpinnerFullScreen caption="Getting share data..." />
                )}
                <BGContainer
                  alignSelf="stretch"
                  justify="center"
                  align="stretch"
                  bgColor={bgColor}
                >
                  {/* <Snowfall
                    snowflakeCount={size === 'medium' ? 60 : 200}
                    radius={[0.5, 5]}
                    speed={[1.0, 3.0]}
                    wind={[-0.5, 1.0]}
                  /> */}
                  <FullScreen handle={handleFullScreen}>
                    {loadSaveModalDisplay && (
                      <LoadSaveModal type={loadSaveModalDisplay} page="rng" />
                    )}
                    {resultSelected !== '' && <Modal result={resultSelected} />}
                    {modifyTitleModal && (
                      <ModifyTitleModal
                        page="rng"
                        phTitle="Number Picker Wheel"
                        phDescription="Pick a random number by wheel"
                      />
                    )}
                    <PageTitle
                      page="rng"
                      title="Number Picker Wheel"
                      caption="Pick a random number by wheel"
                      fullScreenActive={handleFullScreen.active}
                      bgColor={bgColor}
                    />
                    <ContainerTool fullScreenActive={handleFullScreen.active}>
                      <WheelWhiteBox
                        background="baseBackground"
                        align="center"
                        fullScreenActive={handleFullScreen.active}
                        bgImage={!bgImage.on ? null : replaceCDN(bgImage.src)}
                        // round="2rem"
                      >
                        <WheelBox
                          // width="120rem"
                          direction="row"
                          wrap={true}
                          justify="center"
                          fullScreenActive={handleFullScreen.active}
                        >
                          {typeof window === 'undefined' ? ( // for ssr rendering
                            <TurntableBox
                              alignSelf="center"
                              align="center"
                              justify="center"
                              flex="grow"
                              // minHeight="300px"
                            >
                              <WheelPlaceholder size={600} />
                              <Turntable page="rng" choices={[]} size={300} />
                            </TurntableBox>
                          ) : (
                            <Measure
                              bounds
                              onResize={contentRect => {
                                const width = contentRect.bounds.width
                                const maxWidth = handleFullScreen.active
                                  ? 1200
                                  : 600
                                if (width > maxWidth) {
                                  if (turntableBoxSize !== maxWidth) {
                                    setTurntableSize(maxWidth)
                                  }
                                } else if (width !== 0) {
                                  setTurntableSize(width)
                                } else if (width === 0) {
                                  const tempWidth = isMobile ? 300 : maxWidth
                                  setTurntableSize(tempWidth)
                                  showTurntable(null)
                                  // setTimeout(() => , 50)
                                }
                                // this.setState({ dimensions: contentRect.bounds })
                              }}
                            >
                              {({ measureRef }) => (
                                <TurntableBox
                                  ref={measureRef}
                                  alignSelf="center"
                                  align="center"
                                  justify="center"
                                  flex="grow"
                                  fullScreenActive={handleFullScreen.active}
                                  minHeight={
                                    turntableBoxSize
                                      ? `${turntableBoxSize}px`
                                      : '300px'
                                  }
                                >
                                  <WheelPlaceholder size={turntableBoxSize} />
                                  {turnTable}
                                  {/* {typeOption > 0 && handleFullScreen.active && (
                                      <NumberBox>
                                        <NumberContainer onWheel />
                                      </NumberBox>
                                    )} */}
                                  {allResultsOpen && (
                                    <AllResults
                                      page="rng"
                                      fullScreenActive={handleFullScreen.active}
                                      close={() =>
                                        this.setState({
                                          allResultsOpen: false,
                                        })
                                      }
                                    />
                                  )}
                                  {spinQuantityEnabled && <SpinQuantity />}
                                </TurntableBox>
                              )}
                            </Measure>
                          )}
                          <InputBox
                            align="center"
                            justify="center"
                            flex="shrink"
                            fullScreenActive={handleFullScreen.active}
                          >
                            {/* <ToolTitle page="rng" /> */}
                            <NumberContainer />
                            <RelativeBox>
                              <RNGInputs />
                              {handleHideInput.showShield && (
                                <InputShield page="rng" />
                              )}
                            </RelativeBox>
                          </InputBox>
                        </WheelBox>
                        <FloatingBox fullScreenActive={handleFullScreen.active}>
                          {/* <FloatingTitle
                            page="rng"
                            fullScreenActive={handleFullScreen.active}
                          /> */}
                          {typeOption > 0 && (
                            <FloatingDisplay
                              fullScreenActive={handleFullScreen.active}
                            />
                          )}
                        </FloatingBox>
                        {/* <FloatingTitle
                            page="rng"
                            fullScreenActive={handleFullScreen.active}
                          />
                          {typeOption > 0 && (
                            <FloatingDisplay
                              fullScreenActive={handleFullScreen.active}
                            />
                          )} */}
                        {!handleFullScreen.active &&
                          !handleHideInput.shareModeActive && (
                            <UnhideInputButton />
                          )}
                        {/* hiding logic used inside component for animation */}
                        {!handleFullScreen.active &&
                          handleHideInput.hiding &&
                          handleHideInput.shareModeActive && (
                            <ShareModeButton page="rng" />
                          )}
                        <VolumeButton />
                        <AllResultsButton
                          openBox={() => {
                            this.setState({ allResultsOpen: !allResultsOpen })
                          }}
                          isOpened={allResultsOpen}
                        />
                        <FullScreenButton handleFullScreen={handleFullScreen} />
                      </WheelWhiteBox>
                    </ContainerTool>
                  </FullScreen>
                  <ContainerTool
                    fullScreenActive={false}
                    id="ToolSettingsSection"
                  >
                    <MiddleBox />
                    <ToolSettings size={size} page="rng"></ToolSettings>
                    <Versioning size={size} />
                    {/* <AdsBox adSlot={AdSlot.BottomTool} adType="square" /> */}
                  </ContainerTool>
                  {/* <Ezoic
                    alignSelf="center"
                    margin={{ bottom: "2rem", top: "1rem" }}
                    id={EzoicId.belowTool}
                  /> */}
                </BGContainer>

                {/* <FeedbackDonateSection size={size} /> */}
                <ArticleContent content="RNGManual" tool="dice" />
                <Footer />
              </>
            )
          }}
        </ResponsiveContext.Consumer>
      </Layout>
    )
  }
}

export default connect(
  mapState,
  actions,
)(withProvider(withWheelToolHOC(RandomNumberWheel, 'rng')))

export const Head = () => (
  <SEO
    keywords={[
      'random number generator',
      'rng',
      'number generator',
      'random number',
      'pick a number',
      'number randomizer',
      'random number picker',
      'random number wheel',
      'rng picker wheel',
      'number picker wheel',
    ]}
    title="Number Picker Wheel - Pick Random Number by Spinning"
    description="Number Picker Wheel is a specialized random number generator, rng tool which picks a random number differently by spinning a wheel. Free and easy to use."
    tool
    pathname="/tools/random-number-generator/"
    image={RNGSharedImage}
  />
)
